<template>
  <div class="container mt-5">
    <div class="row mt-1">
        <div class="col-md-12 ">
          <profile/>
        </div>
      </div>
      <div class="row mt-4 px-0">
        <div class="col-md-12">
          <projects/>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-md-12">
          <skills/>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-md-12">
          <testimonials/>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-md-12">
          <communities/>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-md-12">
          <footer/>
        </div>
      </div>
      
  </div>
</template>

<script>
// @ is an alias to /src
import profile from '@/components/Home/profile'
import skills from '@/components/Home/skills'
import projects from '@/components/Home/projects'
import communities from '@/components/Home/communities'
import testimonials from '@/components/Home/testimonials'
export default {
  name: 'Home',
  components: {
    profile,
    skills ,
    communities,
    projects,
    testimonials
  }
}
</script>
